import styled, { css } from 'styled-components';
import { Button } from '../Button';
import { InternalButtonSpan } from '../Button/styles';
import { Box, Stack } from '../Core';

export const DropdownListWrapper = styled(Stack)`
  scrollbar-width: thin;

  &:focus,
  &:focus-within {
    outline: none;
  }
`;
DropdownListWrapper.defaultProps = {
  background: 'backgroundDropdown',
  borderRadius: 'borderRadiusDefault',
  overflow: 'hidden',
  boxShadow: '0 1px 5px hsla(0, 0%, 0%, 0.1), 0 1px 15px hsla(0, 0%, 0%, 0.05)',
};

export const DropdownItemWrapper = styled(Button)<{
  isSubmenuOpen?: boolean;
  isHighlighted?: boolean;
}>`
  display: flex;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing6}px;
  border-radius: 0;
  font-size: ${({ theme }) => theme.fontSizeSmall}rem;
  line-height: ${({ theme }) => theme.lineHeightSmall}rem;
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.backgroundInteractiveHover};
  }

  ${({ isSubmenuOpen, isHighlighted, theme }) =>
    (isSubmenuOpen || isHighlighted) &&
    css`
      background: ${theme.backgroundInteractiveHover};
    `}

  ${InternalButtonSpan} {
    flex: 1 1 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: flex-start;
    font-weight: 400;
  }
`;

export const DropdownHeaderWrapper = styled(Box)``;
DropdownHeaderWrapper.defaultProps = {
  px: 'spacing12',
  py: 'spacing6',
  lineHeight: 12 / 11,
  fontSize: 'fontSizeXs',
  fontWeight: 'fontWeightMedium',
  color: 'colorTextDefault',
  background: 'backgroundDropdownHeader',
};
